import { action, makeObservable, observable } from 'mobx';
import * as AWSCognito from 'amazon-cognito-identity-js';
import { LoginDetail } from '../models/LoginDetail';

export class AuthenticationStore {
  @observable
  authenticated: boolean = false;

  @observable
  loginDetail: LoginDetail = LoginDetail.emptyInstance();

  @observable
  cognitoUser: AWSCognito.CognitoUser;
  
  @observable
  newPasswordChallenge: boolean = false;

  @observable
  forgotPassword: boolean = false;

  @observable
  loaded: boolean = false;

  constructor() {
    makeObservable(this);
  }

  isAuthenticated = () => {
    return this.authenticated;
  }

  @action
  loadComplete() {
    this.loaded = true;
  }

  @action
  setForgotPassword = (forgotPassword: boolean) => {
    this.forgotPassword = forgotPassword;
  }

  @action
  setNewPasswordChallenge = (newPasswordChallenge: boolean) => {
    this.newPasswordChallenge = newPasswordChallenge;
  }

  @action
  authenticationComplete() {
    this.authenticated = true;
    this.loginDetail = LoginDetail.emptyInstance();
  }

  @action
  resetLoginDetails = () => {
    this.loginDetail = LoginDetail.emptyInstance();
  }

  @action
  resetAuthentication = () => {
    this.authenticated = false;
    this.newPasswordChallenge = false;
    this.forgotPassword = false;
    this.resetLoginDetails();
  }
}